import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getSignedTranscriptsRpc } from '../../__generated__/chirp/com/hubspot/video/rpc/HubSpotVideoRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});
export const fetchCaptionUrls = (videoId, isAuthedAppPreview = false) => {
  if (isAuthedAppPreview) {
    return chirpClient.call(getSignedTranscriptsRpc, {
      request: {
        videoId
      }
    }).then(resp => resp.transcripts);
  }
  return noAuthHttp.get(`video/v1/public/${videoId}/subtitles`, {
    withCredentials: false,
    query: {
      portalId: PortalIdParser.get()
    }
  });
};